export default __webpack_public_path__ + "static/media/team.ff229f86.svg";